import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { EmailTemplateListItemResponse } from "../models/EmailTemplatesSuccessResponse";

export const GET_EMAIL_TEMPLATES_SUCCESS = "GET_EMAIL_TEMPLATES_SUCCESS";

export interface GetEmailTemplatesSuccessAction extends Action {
  type: typeof GET_EMAIL_TEMPLATES_SUCCESS;
  items: EmailTemplateListItemResponse[];
  organization: OrganizationKeyName;
}

export const getEmailTemplatesSuccessAction = (
  organization: OrganizationKeyName,
  items: EmailTemplateListItemResponse[]
): GetEmailTemplatesSuccessAction => ({
  type: GET_EMAIL_TEMPLATES_SUCCESS,
  items,
  organization,
});
